module.exports = __webpack_public_path__ + "media/images/pic/news-main-blank-fceedb2a19ea1312092a6359bd29c8fb.svg";